<template>
	<!-- 矩阵填空  矩阵填空-->
	<div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">{{$t('main.MatrixFillingInTheBlank')}}</p>
		<el-row :gutter="10" class="question-box">
			
			<el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
				{{ question.quesIndex + 1 }}
			</el-col>
			<el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title"
			@click="setActiveInput(question.qid)">
				
        		<span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				<TitleEditor 
          			:isTest="true"
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="val=>{ question.questionsName = val }" 
				></TitleEditor>
			</el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
			</el-col>
		</el-row>
		
		<div style="max-width: 1100px; overflow-x: auto;">
		<table>
			<tr>
				<th 
					class="td_width" 
					style="text-align: left;width: 200px; max-width: 200px; min-width: 200px;"
				></th>
				<th class="td_width"
					style="text-align: center; width: 200px; max-width: 200px; min-width: 200px;"
					v-for="(option, index2) in questionsSonList[0].optionList" 
					:key="index2"
				>
					<div class="table-th">
						<div @click="setActiveInput(option.oid)">
							<span v-if="isBankViewTest">{{option.labelName}}</span>
							<TitleEditor 
							v-if="!isBankViewTest" 
							class="outline-none" 
							:qid="option.oid" 
							:class="option.oid"  
							:value="option.labelName" 
                    		:actionTitleEditorShow="activeInputId === option.oid"
							@childValueChange="(val) =>columnsNameChange(val, option)" 
							></TitleEditor>
						</div>
						<el-dropdown @command="(c)=>wjdelquestionoption( questionsSonList[0].optionList, index2,c)">
							<span v-if="!isBankViewTest" class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i></span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="$t('main.delete')">{{$t('main.delete')}}</el-dropdown-item>
								<el-dropdown-item :command="$t('main.setUp')">{{$t('main.setUp')}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
            		</div>
				</th>
			</tr>
			<tr v-for="(item, index) in questionsSonList" :key="item.SonId">
				<td class="td_width">
					<div class="table-th">
						<div @click="setActiveInput(item.SonId)">
							<span v-if="isBankViewTest">{{item.questionsName}}</span>
							<TitleEditor 
							v-if="!isBankViewTest" 
							class="outline-none" 
							:qid="item.SonId" 
							:class="item.SonId"  
							:value="item.questionsName" 
                    		:actionTitleEditorShow="activeInputId === item.SonId"
							@childValueChange="(val) =>rowNameChange(val, item)" 
							></TitleEditor>
						</div>
						<el-dropdown @command="questiondel(question.qid, item.SonId)">
							<span v-if="!isBankViewTest" class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i></span>
							<el-dropdown-menu slot="dropdown"><el-dropdown-item>{{$t('main.delete')}}</el-dropdown-item></el-dropdown-menu>
						</el-dropdown>
           			 </div>
				</td>
				<td class="td_width" style="text-align: center" v-for="(option, index2) in item.optionList" :key="index + '-' + index2">
					<fake-input class="textval" />
				</td>
			</tr>
		</table>
		</div>
		<el-row :gutter="10" style="margin-top: 12px !important" v-if="question.isedit && !isBankViewTest">
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="el_item_option item_container_title">
				<i
					class="el-icon-plus el-icon-common"
					@click="addRows"
				>{{$t('main.addRows')}}</i
				>
				<i
					class="el-icon-plus el-icon-common"
					@click="addColumn"
				>{{$t('main.AddColumn')}}</i
				>
				<i
					class="el-icon-plus el-icon-common"
					@click="$refs.batchAddRows.batchAddshow = true"
				>{{$t('main.BatchAddRows')}}</i
				>
				<i
					class="el-icon-plus el-icon-common"
					@click="$refs.batchAddColumns.batchAddshow = true"
				>{{$t('main.BatchAddColumns')}}</i
				>
			</el-col>
		</el-row>
		
		<BatchAddOption 
			ref="batchAddRows"
			:title="$t('main.MatrixRow')" 
			:functionName="'batchAddRows'"
      		:question="question"
			@batchAddRows="batchAddRows"
		/>
		<BatchAddOption 
			ref="batchAddColumns"
			:title="$t('main.MatrixColumn')" 
			:functionName="'batchAddColumns'"
			:question="question"
			@batchAddColumns="batchAddColumns"
		/>
	</div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import OperateWrap from "./collectToBank/operateaWrap.vue"
import FakeInput from '@/components/FakeInput.vue';
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import BatchAddOption from "@/components/myComponents/batchAddOption/batchAddOption.vue"
export default {
	components: {
		FakeInput,
    	TitleEditor,
		BatchAddOption,
		OperateWrap
	},
	data() {
		return {
			questionsSonList: [],
			jz:'jz',
		};
	},
	props: {
		question: {
            type: Object,
            default: () => {
				return {}
			}
		},
		index: { type: Number, default: 0 },
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
	},
	computed: {
    	...mapState(['activeInputId']),
	},
	watch: {
		'question': {
			handler(vnew, vold) {
				this.questionsSonList = vnew.questionsSonList
			},
			deep: true,
			immediate: true
		},
	},
	methods: {
    	...mapActions(['setActiveInput']),
		rowNameChange(val, data) {
			if(val !== data.questionsName){
				this.setSonDefault()
			}
			data.questionsName = val
		},
		setSonDefault() {
			this.question.questionsSonList = this.question.questionsSonList.map((info => {
				this.$set(info, 'isDefault', false)
				return info
			}))
		},
		columnsNameChange(val, data) {
			if(val !== data.labelName){
				this.setOptionDefault()
			}
			data.labelName = val
		},
		setOptionDefault() {
			this.question.questionsSonList = this.question.questionsSonList.map((info => {
				info.optionList = info.optionList.map(val =>{
					this.$set(val, 'isDefault', false)
					return val
				})
				return info
			}))
		},
		addRows() {
			this.setSonDefault()
			this.$emit("addRows", this.$t('main.fillInTheBlanks'));
		},
		addColumn() {
			this.setOptionDefault()
			this.$emit("addColumn",this.$t('main.fillInTheBlanks'));
		},
		batchAddRows(optionArr) {
			this.$emit("batchAddRows",optionArr);
		},
		batchAddColumns(optionArr) {
			this.$emit("batchAddColumns", optionArr );
		},
		batchAdd(options, item, ifRow) {
		  this.$emit("batchAdd", options, item ,this.jz, this.question.id , ifRow);
		},
		//添加自题目
		wjaddquestionoption() {
			//this.question.questionsSonList.push({});
			this.$emit('addquestionitem', this.question);
		},
		setEditIndex(index) {
			this.$emit('setEditIndex', index);
		},
		setEditOptionIndex(childIndex) {
			this.$emit('setEditOptionIndex', childIndex);
		},
		wjdelquestionoption(optionList, index, command) {
      		if (command == this.$t('main.delete')) {
				if (optionList.length == 1) {
          			this.$message.error(this.$t('main.KeepAtLeastOneOption'));
				} else{
				this.$emit("deleteOptionColumn", {index});
				}
			}
      		if (command == this.$t('main.setUp')) {
				this.$emit(
				"wjsetquestionoption",
				this.question,
				optionList,
				index, 
				this.$t('main.matrix'),
				);
			}
		},
		addmatrixquestionsoption(optionList, question) {
			this.$emit('addmatrixquestionsoption', optionList, question);
		},
		questiondel(id, SonId) {
			if (SonId && this.question.questionsSonList.length == 1) {
				this.$message({
					type: "error",
            		message: this.$t('main.KeepAtLeastOneSubTopic'),
				});
			} else{
				this.$emit("questiondel", id, SonId);
			}
		}
	},
	created() {
		//console.log(JSON.stringify(this.question))
		let that = this;
		that.questionsSonList = this.question.questionsSonList;
	}
};
</script>

<style scoped lang="scss">
/deep/ .textval {
	border: 1px solid #ccc !important;
	width: 120px;
	height: 20px;
	margin: 0 auto;
}
table,
table td,
table th {
	border: 1px solid #ccc;
	border-collapse: collapse;
	margin-left: 45px;
	margin-bottom: 20px;
	margin-top: 40px;
	font-weight: normal;
}
tr {
	height: 30px;
}
.td_width {
    text-align: center;
    padding: 1px 20px;
}
.el-dropdown-link {
	cursor: pointer;
	color: #409eff;
	display: inline-block;
	margin-top: 5px;
}
.el-icon-arrow-down {
	font-size: 12px;
}
.delete,
.item {
	font-size: 22px !important;
	line-height: 40px !important;
	// margin-right: 30px !important;
	text-align: right;
	float: right;
	cursor: pointer;
}
.item .el-badge__content.is-fixed {
	top: 10px;
}
.item.drag-handle{
  cursor: move;
}
.el_item_option {
	line-height: 40px;
	// height: 44px;
}

.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}

.el-icon-common-option {
	margin-left: 10px;
	font-size: 22px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}


.item_container_title {
	padding-left: 50px !important;
	padding-right: 0px !important;
}

/deep/.el-textarea .el-textarea__inner {
    border: 1px solid #DCDFE6 !important;
    background-color: #FFF;
}
.table-th{
  display: flex;
  justify-content: center;
}
</style>
